export const tr = {
    'banner-connot-update-archived': 'Arşivdeki reklam düzenlenemez',
    'banner-creative-not-supported': 'Teknik koşullara uygun bir video seçin.',
    'banner-creative-required': 'Kreatif yükleyin',
    'banner-image-required': 'Görsel yükleyin',
    'banner-image-size-modification': 'Sadece aynı boyutta görselle değiştirilebilir',
    'banner-image-size-modification-adaptive': 'Sadece aynı boyutta (uyarlanabilir) görselle değiştirilebilir',
    'banner-image-size-modification-with-size': 'Sadece aynı boyutta görselle değiştirilebilir ({size})',
    'banner-invalid-sitelinkset-usage': 'Hızlı bağlantılar belirtildiyse site bağlantısı da belirtilmelidir.',
    'banner-required-href': "Site URL'sini belirtin",
    'banner-required-href-or-vcard': 'Site bağlantısını belirtin, Turbo sayfa oluşturun veya sanal kartviziti doldurun',
    'banner-required-href-turbo-vcard-organization':
        "Sitenizin bağlantısını girin, Turbo sayfa oluşturun, vCard bilgilerinizi girin veya Yandex.Rehber'den kurum ekleyin",
    'banners-text-language-inconsistent-with-geo-belarusian':
        "Reklam metni Belarusça yazılmış olup seçilen gösterim bölgesine uygun değildir. Gösterimler sadece Beyaz Rusya'da yapılabilir.",
    'banners-text-language-inconsistent-with-geo-default':
        'Reklam metninin dili seçilen gösterim bölgesine uygun değil.',
    'banners-text-language-inconsistent-with-geo-kazakh':
        "Reklam metni Kazakça yazılmış olup seçilen gösterim bölgesine uygun değildir. Gösterimler sadece Kazakistan'da yapılabilir.",
    'banners-text-language-inconsistent-with-geo-turkish':
        "Reklam metni Türkçe yazılmış olup seçilen gösterim bölgesine uygun değildir. Gösterimler sadece Türkiye'de yapılabilir.",
    'banners-text-language-inconsistent-with-geo-ukraine':
        "Reklam metni Ukraynaca yazılmış olup seçilen gösterim bölgesine uygun değildir. Gösterimler sadece Ukrayna'da yapılabilir.",
    'banners-text-language-inconsistent-with-geo-uzbek':
        "Reklam metni Özbekçe yazılmış olup seçilen gösterim bölgesine uygun değildir. Gösterimler sadece Özbekistan'da yapılabilir.",
    'body-invalid-template-query': 'Şablon sadece bir kez kullanılabilir.',
    'body-max-length': {
        one: 'Reklam metni için {count} karakterlik uzunluk sınırı aşıldı',
        some: 'Reklam metni için {count} karakterlik uzunluk sınırı aşıldı',
        many: 'Reklam metni için {count} karakterlik uzunluk sınırı aşıldı',
        none: 'Reklam metni için {count} karakterlik uzunluk sınırı aşıldı'
    },
    'body-max-narrow-length':
        'Reklam metninde en fazla {maxLength} nokta, virgül, iki nokta, noktalı virgül, tırnak işareti ve ünlem işareti kullanılabilir',
    'body-max-world-length': 'Reklam metninde {maxLength} karakterden uzun sözcükler kullanılamaz',
    'body-restricted-chars-in-field':
        'Reklam metninde sadece Latin harfleri, Türkçe, Rusça, Ukraynaca, Belarusça ve Kazakça harfler, sayılar ve noktalama işaretleri kullanılabilir.',
    'body-should-not-be-blank': 'Reklam metnini yazın',
    'callout-text-cannot-be-empty': 'Netleştirme metnini yazın',
    'callout-text-length-exceeded': 'Netleştirmenin uzunluğu aşıldı',
    'callout-text-not-allowed-symbols':
        'Netleştirmelerin metninde sadece Latin harfleri, Türkçe, Rusça, Ukraynaca, Kazakça ve Belarusça harflerin yanı sıra "!" ile "?" dışındaki noktalama işaretleri kullanılabilir.',
    'callout-unknown-error': 'Sorgu yapıldığında hata oluştu. Daha sonra tekrar deneyin',
    'callout-used': 'Başka reklama bağlı olan netleştirme silinemez',
    'callouts-max-size': 'Bir reklam için en fazla {maxSize} netleştirme belirtilebilir',
    'cannot-be-empty': 'Alan boş bırakılamaz',
    'choose-correct-template': 'Doğru şablonu seçin',
    'collection-is-inaccessible': 'Koleksiyon kullanılamıyor',
    'description-cannot-be-less-than-max': 'Minimum karakter sayısı: {minLength}',
    'description-cannot-be-more-than-max': 'Maksimum karakter sayısı: {maxLength}',
    'display-href-invalid-template-query': 'Şablon sadece bir kez kullanılabilir',
    'displayhref-max-length': 'Gösterilen bağlantının izin verilen uzunluğu {maxLength} karakter aşıldı',
    'domain-invalid-value': 'Alan adı formatı yanlış',
    'duplicate-error': 'Toplu değişiklik yapıldığında her boyut için sadece bir görsel seçilebilir',
    'equal-pixels': 'Aşağıdaki sağlayıcıların gösterim sayaçları birden fazla kez belirtilir: {providerNames}.',
    'gif-file-error-text': 'gif dosyası işlenemiyor',
    'href-file-format-invalid': 'Bağlantı üzerinden görsel yüklenemedi. Sunucu 400 hatası verdi',
    'href-file-invalid': 'Dosya formatı yanlış',
    'href-image-file-size-invalid': 'Dosya boyutu çok büyük',
    'href-invalid': 'Bağlantı formatı yanlış',
    'href-invalid-or-no-scheme': 'Bağlantı formatı geçersiz veya şema belirtilmedi',
    'href-invalid-or-not-https-scheme': 'Geçersiz bağlantı formatı veya https olmayan şema ',
    'href-invalid-value': 'Bağlantı formatı yanlış',
    'href-max-length': 'İzin verilen bağlantı uzunluğu {maxLength} karakter aşıldı',
    'href-null': 'Bağlantı boş bırakılamaz',
    'href-or-turbo-required': 'Site bağlantısını belirtin, Turbo sayfa oluşturun ',
    'href-should-not-be-blank': 'Site bağlantısını belirtin',
    'image-gallery-empty-images': 'Galeride görsel yok',
    'image-invalid-file-size-param': 'Dosya izin verilen boyuttan büyük ({maxSize} KB)',
    'image-invalid-format': 'Geçersiz dosya türü. GIF, JPEG ve PNG grafik formatlarını kullanın',
    'image-invalid-formats': 'Geçersiz dosya türü. Görsel formatları kullanın: {formats}',
    'image-invalid-sizes': 'Görsel boyutu geçersiz',
    'image-invalid-sizes-mc-banner': '240×400 px boyutunda kreatif kullanın',
    'image-not-equal': 'Görsel boyutu koşullara uygun değil',
    'image-not-equal-height': 'Görselin yüksekliği uygun değil: {height} piksel',
    'image-not-equal-width': 'Görselin genişliği uygun değil: {width} piksel',
    'image-not-equal-width-height': 'Görselin boyutu koşullara uygun değil: {width} × {height} piksel',
    'image-too-big': 'Görselin boyutu limitleri aşıyor',
    'image-too-big-height': 'Görselin yüksekliği limiti aşıyor: {height} piksel',
    'image-too-big-width': 'Görselin genişliği limiti aşıyor: {width} piksel',
    'image-too-big-width-height': 'Görselin boyutu limitleri aşıyor: {width} × {height} piksel',
    'image-too-small': 'Görselin boyutu limitlerin altında',
    'image-too-small-height': 'Görselin yüksekliği limitlerin altında: {height} piksel',
    'image-too-small-width': 'Görselin genişliği limitlerin altında: {width} piksel',
    'image-too-small-width-height': 'Görselin boyutu limitlerin altında: {width} × {height} piksel',
    'incorrect-measures': 'Yanlış format',
    'incorrect-pixel-url': 'Girdiğiniz kod, izin verilen sayaçların formatına uygun değil.',
    'incorrect-ya-auditory-pixel-url':
        'Girdiğiniz kod, Yandex.Audience pikselinin kod formatıyla aynı değil. Piksel kodunu almak için Yandex.Audience servisini kullanın',
    'invalid-choice-value': 'Geçersiz değer seçildi',
    'invalid-link': 'Bağlantı hatalı',
    'invalid-promotion-collection-link': 'Yandex.Koleksiyonlar bağlantısı girilmedi',
    'invalid-promotion-video-link': 'Video bağlantısı girilmedi',
    'must-be-empty': 'Bu alan boş olmalıdır',
    'no-right-to-pixel':
        'Sayaç formatı yanlış. İstatistik toplamak için {counters} sayacını kullanabilirsiniz. Bağlantı %random% makrosunu içermelidir.',
    'not-enough-cards-in-collection': 'Koleksiyon en az {count} kart içermelidir',
    or: 'veya',
    'organization-not-found': "Seçilen kurum Yandex.Rehber'de bulunamadı",
    'template-not-allowed': 'Seçilen şablon geçersiz',
    'title-invalid-template-query': 'Şablon sadece bir kez kullanılabilir',
    'title-max-length': 'İzin verilen başlık uzunluğu olan {maxLength} karakter aşıldı',
    'title-max-length-word': 'Başlıkta {maxLength} karakterden uzun sözcükler kullanılamaz',
    'title-max-narrow-length':
        'Başlıkta en fazla {maxLength} nokta, virgül, iki nokta, noktalı virgül, tırnak işareti ve ünlem işareti kullanılabilir',
    'title-restricted-chars-in-field':
        'Başlıkta sadece Latin harfleri, Türkçe, Rusça, Ukraynaca, Belarusça ve Kazakça harfler, sayılar ve noktalama işaretleri kullanılabilir',
    'title-should-not-be-blank': 'Başlığı belirtin',
    'tns-id-cannot-be-empty': 'Bu alan boş bırakılamaz',
    'tns-id-length': {
        one: "TNS ID'nin {maxLength} karakter olan maksimum uzunluğu aşıldı",
        some: "TNS ID'nin {maxLength} karakter olan maksimum uzunluğu aşıldı",
        many: "TNS ID'nin {maxLength} karakter olan maksimum uzunluğu aşıldı",
        none: "TNS ID'nin {maxLength} karakter olan maksimum uzunluğu aşıldı"
    },
    'tns-id-restricted-characters': 'Alan, geçersiz karakterler içeriyor',
    'turbo-gallery-href-max-length':
        'Zenginleştirilmiş interaktif yanıt için izin verilen bağlantı uzunluğu {maxLength} karakter aşıldı',
    'turbo-href-params-length': 'İzleme parametrelerinin izin verilen uzunluğu {maxLength} karakter aşıldı',
    'turbo-required': 'Turbo sayfa seçilmeli',
    'unknown-error-header': 'Beklenmeyen bir hata oluştu',
    'unknown-error-text': 'Beklenmeyen bir hata oluştu. Daha sonra tekrar deneyin',
    'video-is-inaccessible': 'Video kullanılamıyor'
};
